import { useState } from "react";
import { _colorText, _size, _sizeText, _style } from "../../core/core";
import { ModalBase } from "../Modal/ModalBase";
import { Text } from "../texts/text";

export interface ImagePreviewProps {
  title: string;
  url: string;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({ title, url }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <div className="card-job-b-row">
      <Text size={_sizeText.m} color={_colorText.neutral}>
        {title}
      </Text>
      <ModalBase
        title={title}
        button_text="Посмотреть"
        button_size={_size.M}
        button_style={_style.link}
        active={isModalOpen}
        setActive={setIsModalOpen}
      >
        <img style={{ borderRadius: "12px" }} src={`https://viw.im${url}`} />
      </ModalBase>
    </div>
  );
};
